export enum AnnouncementType {
  category = "category",
  singleTag = "singleTag",
  multipleTags = "multipleTags",
}
